module.exports = __webpack_public_path__ + "img/Ace Round.ae34e365.jpg";